import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';

export type LandingBottomCtaProps = {
  title: string;
  lead: string;
  quoteLabel: string;
  /** Synlig text på primärknapp (standard: Begär offert) */
  ctaLabel?: string;
  onQuote: (label: string) => void;
  phoneHref: string;
  phoneDisplay: string;
  onPhoneClick?: () => void;
};

const LandingBottomCta: React.FC<LandingBottomCtaProps> = ({
  title,
  lead,
  quoteLabel,
  ctaLabel = 'Begär offert',
  onQuote,
  phoneHref,
  phoneDisplay,
  onPhoneClick,
}) => (
  <div className="relative z-10 border border-slate-800 bg-slate-900/35 p-8 text-center text-white">
    <h2 className="mb-4 text-3xl font-bold">{title}</h2>
    <p className="mx-auto mb-8 max-w-xl text-lg opacity-90">{lead}</p>
    <div className="flex flex-col justify-center gap-4 sm:flex-row">
      <button
        type="button"
        onClick={() => onQuote(quoteLabel)}
        className="inline-flex items-center justify-center rounded-none bg-white px-8 py-3 font-medium text-purple-600 transition-colors hover:bg-gray-100"
      >
        {ctaLabel}
        <ArrowRight className="ml-2" size={18} aria-hidden />
      </button>
      <a
        href={phoneHref}
        onClick={onPhoneClick}
        className="inline-flex items-center justify-center rounded-none border-2 border-white bg-transparent px-8 py-3 font-medium text-white transition-colors hover:bg-white hover:text-purple-600"
      >
        <Phone className="mr-2" size={18} aria-hidden />
        {phoneDisplay}
      </a>
    </div>
  </div>
);

export default LandingBottomCta;
